import { BrainIcon, ImageIcon, LayersIcon, MicIcon, PuzzleIcon, ShuffleIcon, Volume2Icon } from "lucide-react";

export const gameShowcase = [
  { id: "g1", title: "Match the pairs", example: "la manzana ↔ the apple", icon: PuzzleIcon },
  { id: "g2", title: "Picture match", example: "el queso → pick the cheese", icon: ImageIcon },
  { id: "g3", title: "Listen & choose", example: "“la bolsa” → the bag", icon: Volume2Icon },
  { id: "g4", title: "Fill the gap", example: "Quiero ___ kilo de tomates", icon: LayersIcon },
  { id: "g5", title: "Memory cards", example: "Flip, remember, match", icon: BrainIcon },
  { id: "g6", title: "Say it out loud", example: "¿Cuánto cuesta el kilo?", icon: MicIcon },
  { id: "g7", title: "Word order", example: "¿Dónde · está · el · mercado?", icon: ShuffleIcon },
];

export const pairRoutes = [
  { code: "en", label: "from English" },
  { code: "ru", label: "из русского" },
  { code: "it", label: "dall'italiano" },
  { code: "de", label: "aus dem Deutschen" },
  { code: "fr", label: "depuis le français" },
  { code: "uk", label: "з української" },
];

export const translatorJourney = [
  { id: "t1", title: "You look it up", body: "Tuesday, at the shop: “bag” → la bolsa. Saved automatically." },
  { id: "t2", title: "It shows up in a lesson", body: "Thursday's market lesson asks you to hear and pick “la bolsa”, tagged as yours." },
  { id: "t3", title: "You review it in My Words", body: "It moves from New to Practising as you get it right." },
  { id: "t4", title: "It sticks", body: "Five correct answers later, it's Mastered — and reviewed less often." },
];
